import type { OrderImageTypes } from '@hero/schema';
import { fileToBase64 } from '@hero/web-utils';

export type OrderImageUploadPayload = {
  newImages: Array<{
    image: { upload: string };
    type: OrderImageTypes;
    customRef?: string;
  }>;
  pod?: { podRef: string };
};

/**
 * Builds the `orderUpdate` slice for new images.
 * When a podRef is provided and `applyAsOrderPodRef` is true (default),
 * also sets `pod.podRef` so the order-level POD ref stays in sync.
 */
export async function buildOrderImageUpdatePayload(opts: {
  files: File[];
  imageType: OrderImageTypes;
  podRef?: string;
  /** When true (default), write the ref to `order.podRef` as well. */
  applyAsOrderPodRef?: boolean;
}): Promise<OrderImageUploadPayload> {
  const trimmedRef = opts.podRef?.trim() || undefined;
  const applyAsOrderPodRef = opts.applyAsOrderPodRef ?? true;

  const newImages = await Promise.all(
    opts.files.map(async file => ({
      image: { upload: await fileToBase64(file) },
      type: opts.imageType,
      ...(trimmedRef ? { customRef: trimmedRef } : {}),
    })),
  );

  return {
    newImages,
    ...(applyAsOrderPodRef && trimmedRef ? { pod: { podRef: trimmedRef } } : {}),
  };
}
